var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagUnitedKingdom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.8506C24.8366 32.8506 32 25.6871 32 16.8506C32 8.01403 24.8366 0.850586 16 0.850586C7.16344 0.850586 0 8.01403 0 16.8506C0 25.6871 7.16344 32.8506 16 32.8506Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.30709 7.10938C2.05028 8.74456 1.10259 10.6292 0.550781 12.6767H8.87441L3.30709 7.10938Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4484 12.6766C30.8966 10.6292 29.9488 8.74456 28.6921 7.10938L23.1249 12.6766H31.4484Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.550781 21.0249C1.10266 23.0723 2.05034 24.957 3.30709 26.5921L8.87422 21.0249H0.550781Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7411 4.15823C24.1059 2.90142 22.2213 1.95373 20.1738 1.40186V9.72542L25.7411 4.15823Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25879 29.5432C7.89398 30.8 9.77866 31.7477 11.826 32.2996V23.9761L6.25879 29.5432Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.826 1.40186C9.7786 1.95373 7.89391 2.90142 6.25879 4.15817L11.826 9.72536V1.40186Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1738 32.2996C22.2212 31.7477 24.1059 30.8 25.741 29.5433L20.1738 23.9761V32.2996Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1249 21.0249L28.6921 26.5922C29.9488 24.957 30.8966 23.0723 31.4484 21.0249H23.1249Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8646 14.7636H18.0871H18.087V0.986023C17.4038 0.897086 16.7073 0.850586 16 0.850586C15.2926 0.850586 14.5962 0.897086 13.9131 0.986023V14.7635V14.7636H0.135438C0.0465 15.4468 0 16.1433 0 16.8506C0 17.558 0.0465 18.2544 0.135438 18.9375H13.9129H13.913V32.7151C14.5962 32.8041 15.2926 32.8506 16 32.8506C16.7073 32.8506 17.4038 32.8041 18.0869 32.7151V18.9376V18.9376H31.8646C31.9535 18.2544 32 17.558 32 16.8506C32 16.1433 31.9535 15.4468 31.8646 14.7636Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.174 21.0245L27.3137 28.1642C27.6421 27.836 27.9553 27.4928 28.2542 27.137L22.1416 21.0244H20.174V21.0245Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8263 21.0244H11.8262L4.68652 28.1641C5.01477 28.4925 5.35796 28.8057 5.71371 29.1046L11.8263 22.9919V21.0244Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8263 12.677V12.6769L4.68659 5.53711C4.35822 5.86536 4.04497 6.20855 3.74609 6.5643L9.85878 12.677H11.8263V12.677Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.174 12.677L27.3138 5.53712C26.9855 5.20874 26.6423 4.89549 26.2866 4.59668L20.174 10.7094V12.677Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16795"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.850586)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUnitedKingdom);
export default __webpack_public_path__ + "static/media/flag_united_kingdom.c27aa233e7ebbe2afe512da55d73a003.svg";
export { ForwardRef as ReactComponent };